import AdUnit from "@/components/AdUnit";
import { useAdsContext } from "@/context/AdsContext";
import { cn } from "@/lib/utils";

const MicrositeExtras = ({ style, noBrand }) => {
  const { placement } = useAdsContext();

  return (
    <>
      <div className="z-10 relative pb-[90px]">
        {placement?.microsite_sid_sticky?.enabled === true && (
          <div className={cn(style?.collaborationImage ? "" : "pt-20")} />
        )}
        <AdUnit
          name={noBrand ? "sdotsite_microsite_bottom" : "microsite_bottom"}
          containerClassName="mx-3"
        />
      </div>
      <AdUnit
        name={noBrand ? "sdotsite_microsite_sticky" : "microsite_sticky"}
        imgClassName="max-h-[180px] sm:max-h-[100px]"
        containerClassName="max-h-[180px] sm:max-h-[100px]"
        className="flex justify-center items-center bg-gray-200 max-h-[180px] sm:max-h-[100px]"
        sticky
      />
    </>
  );
};

export default MicrositeExtras;
